export default __webpack_public_path__ + "static/ideal_choice-7d773759b7f9484a2f18115f37cf2948.webp";